import Logo from "./Logo";

const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/5 bg-ink">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 md:px-8 md:pt-24">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
        <div>
          <Logo />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-stone-500">
            Kitchen utensils, traditional wares and brass pooja articles.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 font-mono text-[11px] uppercase tracking-[0.22em] text-stone-500">
          <a href="#collection" data-testid="footer-shelves-link" className="transition-colors hover:text-brand-brass">
            The Shelves
          </a>
          <a href="#visit" data-testid="footer-visit-link" className="transition-colors hover:text-brand-brass">
            Visit
          </a>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="text-outline mt-14 select-none text-center font-display text-[17vw] font-black leading-[0.85] tracking-tight"
      >
        REVATHY
      </div>

      <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 text-center md:flex-row md:text-left">
        <span className="text-xs text-stone-600">
          © {new Date().getFullYear()} Revathy Stores · Besant Nagar, Chennai
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-stone-600">
          Aluminium · Steel · Non-stick · Brass
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
